<template>
    <div id="anchor-zig-zag" :class="zigzag.fragmentClasses" class="row mx-0">
        <div v-for="(zigZag, index) in zigzag.zigZagItems" :key="'zigzag-' + index" class="col-12 p-md-0">
            <div
                :class="`card ob1-push ob1-push-zigzag ob1-push-shadow-right ${index === zigzag.zigZagItems.length-1? additionalClasses:''} ${definePictureLayout(index)}`"
            >
                <div class="card-item">
                    <div
                        v-if="zigZag.image"
                        class="card-header"
                        :class="[index === zigzag.zigZagItems.length - 1 ? additionalClasses : '',
                                 withImageResize ? 'zigzag-image-container' : ''
                        ]"
                    >
                        <ob1-picture :css-classes="'card-img-top'" :visual="zigZag.image" />
                    </div>
                    <div v-if="zigZag.video" class="card-header">
                        <video-container :css-classes="'card-img-top'" :src="zigZag.video" />
                    </div>
                </div>
                <div class="card-item">
                    <div v-for="(item, itemIndex) in zigZag.body" :key="'body-' + itemIndex" class="card-body">
                        <h3 class="card-title" data-clamp="2">
                            {{ item.title }}
                        </h3>
                        <p class="card-text" v-html="item.textHtml" />
                        <p v-if="item.btnLabel !== ''" class="pb-2 card-btn">
                            <a
                                :href="item.btnLink"
                                :data-oevent-category="item.btnTms.tagZone"
                                :data-oevent-action="item.btnTms.tagName"
                                :data-oevent-label="item.btnTms.tagTarget"
                                class="btn btn-secondary"
                            >{{ item.btnLabel }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import VideoContainer from "../../components/VideoContainer.vue";
import {PushZigZagDto} from "../../../showcase/models/OfferApiResponse";

export default defineComponent({
    name: "EditorialPush",
    components: {
        VideoContainer
    },
    props: {
        zigzag: {
            type: Object as PropType<PushZigZagDto>,
            required: true
        },
        additionalClasses: {
            type: String,
            default: ""
        },
        withImageResize: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        definePictureLayout(index: number) {
            const oddClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-even ob1-push-md-shadow-left" : "ob1-push-zigzag-odd"
            const evenClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-odd" : "ob1-push-zigzag-even ob1-push-md-shadow-left"
            const startIndex = this.zigzag?.firstIsEven ? 0 : 1
            const computedIndex = index + startIndex
            const isEven = computedIndex % 2 === 0
            return isEven ? evenClass : oddClass
        }
    }
});
</script>

<style scoped lang="scss">
@import 'ob1_common';

.zigzag-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.zigzag-image-container img.card-img-top {
    max-width: 645px;
    max-height: 484px;
    width: auto;
    height: auto;
}

</style>
